// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22H2V2ZM4 4V6H6V4H4ZM18 4V6H20V4H18ZM20 8H18V11H20V8ZM20 13H18V16H20V13ZM20 18H18V20H20V18ZM16 13V11H8V13H16ZM6 20V18H4V20H6ZM4 16H6V13H4V16ZM4 11H6V8H4V11Z"}}]};

const Film1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'film-1-filled',
    ref,
    icon: element,
  },
));

Film1FilledIcon.displayName = 'Film1FilledIcon';

export default Film1FilledIcon;
